import { render, staticRenderFns } from "./ScanCode.vue?vue&type=template&id=40bb8a18"
import script from "./ScanCode.vue?vue&type=script&lang=ts"
export * from "./ScanCode.vue?vue&type=script&lang=ts"
import style0 from "./ScanCode.vue?vue&type=style&index=0&id=40bb8a18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports